import { useUser } from "../Contexts/user";

export default {
  getWorkflows: (token) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `https://www.wrike.com/api/v4/workflows`,
      requestOptions
    ).then((res) => res.json());
  },
};
